// extracted by mini-css-extract-plugin
module.exports = {"search__hero__title":"styles_search__hero__title__0IG78","search__form":"styles_search__form__U69nc"};